import React, { useState } from 'react';
import {
  ScrollRestoration, useLocation, useNavigate,
} from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap5';

import StepTab from 'components/new_ui/Tabs/StepTab';
import routes from 'app/routes';
import Invite from 'components/Managers/Coaches/Pages/Invite/Index';

export default function Index() {
  const [showInvite, setShowInvite] = useState(false);

  const stateLocation = useLocation();
  const navigate = useNavigate();

  const coaches = stateLocation.state?.coaches;

  const confirmInvite = () => {
    setShowInvite(true);
  };

  const onCancelInvite = () => {
    navigate(routes.managers.coaches.index);
  };

  const onSuccessInvite = () => {
    navigate(routes.managers.coaches.index);
  };

  return (
    <>
      <StepTab total={2} current={2} />

      <div className="content">
        <Row>
          <Col lg={{ span: 6, order: 'last' }}>
            <div className="bg-photo bg-managers-members-success-photo" />
          </Col>

          <Col lg={{ span: 6, order: 'first' }}>
            <div className="py-4 px-sm-4 p-xxl-5">
              <h1 className="mb-5">Success!</h1>

              <p>
                Your Coaches have been successfully imported into the LeggUP platform.
                Send them an invitation so they can complete their profiles and prepare for
                matching with members.
              </p>

              <div className="d-flex justify-content-end">
                <Button
                  className={coaches.length === 0 ? 'disabled' : ''}
                  onClick={confirmInvite}
                >
                  Invite
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      {showInvite && (
      <Invite
        coaches={coaches.map((item) => ({
          attributes: {
            full_name: `${item.firstName} ${item.lastName}`,
            email: item.email,
          },
        }))}
        cancelCallback={onCancelInvite}
        sentCallback={onSuccessInvite}
      />
      )}
      <ScrollRestoration />
    </>
  );
}
